// extracted by mini-css-extract-plugin
export default {"tabelacapag":"CapagTable_tabelacapag__6sSXw"};